import React from "react";
import "./RightPlayGames.css";

const PROMO_BANNERS = [
  "roulette.webp",
  "sicbo.webp",
  "dragontiger.webp",
  "lucky7.webp",
  "andar-bahar.webp",
];

const GAME_TILES = [
  "17627670321128629.webp",
  "17627670394952739.webp",
  "17627670461429100.webp",
  "17889579179160978.png",
  "17627670585808315.webp",
  "17627670659323746.webp",
  "17627670718442303.webp",
  "17627670774655812.webp",
  "17838974711553317.png",
  "17627670914326964.webp",
  "17627671036352194.webp",
  "17838974792520238.png",
  "17627671249048208.webp",
  "17840351515120102.png",
  "17816910456586236.png",
  "17627674617189985.webp",
  "17627671431487612.webp",
  "17627671491957490.webp",
];

const RightPlayGames = () => {
  return (
    <aside className="right-play-games" aria-label="Play games">
      {/* Top: large vertical promo banners */}
      <section className="right-play-games-section">
        <h2 className="right-play-games-title">Play Games</h2>

        <div className="right-promo-scroll">
          {PROMO_BANNERS.map((imageName) => (
            <button key={imageName} type="button" className="right-promo-card">
              <img
                src={`${process.env.PUBLIC_URL}/Images/right-sidebar/${imageName}`}
                alt=""
                loading="lazy"
              />
            </button>
          ))}
        </div>
      </section>

      {/* Bottom: 2-column game tiles */}
      <section className="right-play-games-section">
        <h2 className="right-play-games-title">Play Games</h2>

        <div className="right-tiles-scroll">
          <div className="right-tiles-grid">
            {GAME_TILES.map((imageName) => (
              <button key={imageName} type="button" className="right-tile-card">
                <img
                  src={`${process.env.PUBLIC_URL}/Images/right-sidebar/${imageName}`}
                  alt=""
                  loading="lazy"
                />

                <span className="right-play-overlay">▶</span>
              </button>
            ))}
          </div>
        </div>
      </section>
    </aside>
  );
};

export default RightPlayGames;
